import React from 'react';

import { TextField, useRecordContext } from 'react-admin';

import { get } from 'lodash';

import { Grid, Box, Typography } from '@mui/material';
import Answer from '../Answer';

import languages, { Languages } from '../../../../constants/languages';
import conflictFields from '../../../../constants/conflictFields';
import { TextQuestionParameters } from '../../questionParameters';

const CONTENT = {
  [languages.SV]: 'Stad',
  [languages.EN]: 'City',
  [languages.DE]: 'Stadt',
};

const ValueField = () => {
  const record = useRecordContext();

  const value = get(record, 'value');
  const sx = get(record, 'sx', {});

  return <TextField record={{ value }} sx={sx} source="value" emptyText="-" fontWeight="bold" />;
};

const City = ({ extraParameters }: { extraParameters?: TextQuestionParameters }) => {
  const record = useRecordContext();

  const language = record?.language as Languages;

  return (
    <Answer
      label={extraParameters?.label ?? CONTENT[language]}
      datapoint={conflictFields.CITY}
      identificationInfo={undefined}
      source="city"
    >
      <ValueField />
    </Answer>
  );
};

City.ValueField = ValueField;

City.Nested = ({ source, extraParameters }: {
  source?: string;
  extraParameters?: TextQuestionParameters;
}) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const record = useRecordContext();
  const sx = get(record, 'sx', {});

  const language = record?.language as Languages;

  return (
    <Grid
      size={{
        xs: 12,
        md: 3,
      }}
    >
      <Box display="flex" flexDirection="column">
        <Typography variant="label">{extraParameters?.label ?? CONTENT[language]}</Typography>
        <TextField
          source={source ?? 'city'}
          emptyText="-"
          sx={sx}
        />
      </Box>
    </Grid>
  );
};

export default City;
